export const meridian =["AM","PM"];